import { render, staticRenderFns } from "./ScoutTopicLiked.vue?vue&type=template&id=db1be49e"
import script from "./ScoutTopicLiked.vue?vue&type=script&lang=js"
export * from "./ScoutTopicLiked.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports